/**
 * EPIC ACCESSIBILITY: MEDIA COMPLIANCE ADD-ON
 * Runs alongside the legacy engine to dynamically route and format 
 * user-generated transcripts from window.MediDyneTranscripts.
 */

document.addEventListener('DOMContentLoaded', function() {
    // Check if the marketing team has added any transcripts to the Liquid object
    if (typeof window.MediDyneTranscripts !== 'undefined' && Object.keys(window.MediDyneTranscripts).length > 0) {
        
        // Delay slightly to allow the primary v3.7.6 engine to finish its DOM manipulations
        setTimeout(function() {
            var keys = Object.keys(window.MediDyneTranscripts);
            
            keys.forEach(function(videoId) {
                // Hunt for any video or iframe containing the marketing team's ID string
                var $mediaTarget = jQuery('iframe[src*="' + videoId + '"], video[data-id="' + videoId + '"], [data-video-id="' + videoId + '"], source[src*="' + videoId + '"]').closest('native-video, .video-wrapper, video, iframe, video-media, .product__media');
                
                $mediaTarget.each(function() {
                    var $media = jQuery(this);
                    var $wrapper = $media.parent();
                    
                    // Prevent duplicate injections if the script runs multiple times
                    if ($wrapper.find('.epic-transcript-overlay').length === 0) {
                        var transcriptHtml = window.MediDyneTranscripts[videoId];
                        var transcriptId = 'transcript-' + Math.random().toString(36).substr(2, 9);
                        
                        // Build the accessible accordion using the established Medi-Dyne structure
                        var transcriptBlock = `
                            <div class="epic-transcript-overlay epic-transcript-wrapper" style="margin-top: 1rem; width: 100%;">
                                <button type="button" class="transBtn trnsBtn toggle-transcript-addon-btn" aria-expanded="false" aria-controls="${transcriptId}" style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin-bottom: 0 !important; background: #fff; border: 1px solid #ccc; padding: 10px; cursor: pointer;">
                                    <span class="btn-text">View Transcript</span>
                                    <i class="fa-solid fa-chevron-down" aria-hidden="true" style="margin-left: 10px;"></i>
                                </button>
                                <div id="${transcriptId}" class="transcript-content" hidden style="padding: 1.5rem; border: 1px solid #1C479A; border-top: none; background: #ffffff; color: #000000; text-align: left; font-size: 15px; line-height: 1.6;">
                                    ${transcriptHtml}
                                </div>
                            </div>
                        `;
                        
                        $media.after(transcriptBlock);
                    }
                });
            });

            // Global Event Listener for the newly injected Toggle Buttons
            jQuery(document).off('click.epicAddon').on('click.epicAddon', '.toggle-transcript-addon-btn', function() {
                var $btn = jQuery(this);
                var transcriptId = $btn.attr('aria-controls');
                var $content = jQuery('#' + transcriptId);
                var isExpanded = $btn.attr('aria-expanded') === 'true';
                var $icon = $btn.find('i.fa-solid');
                var $text = $btn.find('.btn-text');
                
                // Toggle the panel and ARIA state
                $btn.attr('aria-expanded', !isExpanded);
                $content.prop('hidden', isExpanded);
                
                // Swap text and icon based on state
                if (isExpanded) {
                    $text.text('View Transcript');
                    $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
                } else {
                    $text.text('Hide Transcript');
                    $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
                }
            });

        }, 800); 
    }
});